const API_VERSION = {
  V1: "v1/api",
};

const API_ROUTES = {
  V1: {
    LOGIN: `${API_VERSION.V1}/accounts/sign-in/`,
    LOGOUT: `${API_VERSION.V1}/accounts/logout/`,
    SIGNUP: `${API_VERSION.V1}/accounts/sign-up/`,
    SOCIAL_LOGIN: `${API_VERSION.V1}/accounts/social-auth/`,
    GET_HOTELS: `${API_VERSION.V1}/accounts/hotels/`,
    GET_CITYS: `${API_VERSION.V1}/accounts/cities/`,
    CREATE_TRIP: `${API_VERSION.V1}/accounts/trip/`,
    ADD_TO_BAG: `${API_VERSION.V1}/buyer/bag/`,
    // GET_HOME_PAGE: `${API_VERSION.V1}/accounts/landing_page`,
    GET_HOME_PAGE: `${API_VERSION.V1}/accounts/landing-pages/`,
    GET_PRODUCTS: `${API_VERSION.V1}/accounts/products/`,
    GET_PROFILE: `${API_VERSION.V1}/accounts/profile/`,
    GET_DESIGNERS: `${API_VERSION.V1}/seller/sellers/`,
    GET_CATEGORIES: `${API_VERSION.V1}/accounts/categories/`,
    GET_SELLER_DETAILS: `${API_VERSION.V1}/seller/seller/`,
    GET_FAVOURITE_PRODUCTS: `${API_VERSION.V1}/accounts/favourite-product/`,
    GET_GUEST_USER_FLOW: `${API_VERSION.V1}/accounts/guest-session/`,
    CLEAR_BAG: `${API_VERSION.V1}/accounts/trip/`,
    SIZE: `${API_VERSION.V1}/accounts/products/[ID]/sizes/?color=`,
    BAG_CHECKOUT: `${API_VERSION.V1}/buyer/order-confirmation/`,
    RECOMMENDED: `${API_VERSION.V1}/buyer/recommendations/`,
    CLOSET: `${API_VERSION.V1}/buyer/my-closet/?type=`,
    CANCEL_ORDER: `${API_VERSION.V1}/buyer/orders/cancel/`,
    UPDATE_ORDER_ITEM_STATUS: `${API_VERSION.V1}/buyer/order-items/`,
    UPDATE_TRIP_DATE: `${API_VERSION.V1}/buyer/my-closet/`,
    CHECKOUT_KEEP_ITEMS: `${API_VERSION.V1}/buyer/checkout/`,
    STATUS_COLOR: `${API_VERSION.V1}/buyer/order-status/`,
    FAVOURITE_LISTING: `${API_VERSION.V1}/buyer/favorite-products/`,
    REVIEW: `${API_VERSION.V1}/buyer/reviews/`,
    ORDER_HISTORY: `${API_VERSION.V1}/buyer/order-history/`,
    CUSTOMER_SUPPORT: `${API_VERSION.V1}/accounts/support-information/`,
    TERMS_AND_CONDITION: `${API_VERSION.V1}/accounts/terms-and-conditions/`,
    PRIVACY_POLICY: `${API_VERSION.V1}/accounts/privacy-policy/`,
    FORGET_PASSWORD: `${API_VERSION.V1}/accounts/forgot-password/`,
    RESET_PASSWORD: `${API_VERSION.V1}/accounts/reset-password/`,
    DOWNLOAD_INVOICE: `${API_VERSION.V1}/buyer/invoices/`,
    RESET_LINK_CHECK: `${API_VERSION.V1}/accounts/reset-link-check/`,
    SELLER_COLOURS: `${API_VERSION.V1}/accounts/colors/`,
    SELLER_SIZES: `${API_VERSION.V1}/accounts/sizes/`,
    FAQ: `${API_VERSION.V1}/accounts/faqs/`,
    NEWSLETTER: `${API_VERSION.V1}/accounts/newsletter/`,
    UPLOAD_IMAGE: `${API_VERSION.V1}/accounts/upload-image/`,
  },
};

export default API_ROUTES;
